import { PlusOutlined } from '@ant-design/icons';
import React from 'react';
import { AddRuleSetButton } from './ScopeSectionsStyledComponents';

interface AddScopeSectionProps {
  disabled?: boolean;
  onAdd: () => void;
}

const AddScopeSection: React.FC<AddScopeSectionProps> = ({ disabled = false, onAdd }) => (
  <AddRuleSetButton
    aria-label="Add rule set"
    icon={<PlusOutlined />}
    type="primary"
    disabled={disabled}
    onClick={onAdd}
  >
    Add rule set
  </AddRuleSetButton>
);

export default AddScopeSection;
